const gameStages = [
    {
        office: 'open',
        laboratory: 'locked',
        library: 'locked',
        fourJokers: 'locked',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'newGame'
    },
    {
        office: 'complete',
        laboratory: 'open',
        library: 'open',
        fourJokers: 'open',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'open',
        library: 'open',
        fourJokers: 'complete',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'open',
        library: 'complete',
        fourJokers: 'complete',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'open',
        library: 'complete',
        fourJokers: 'open',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'complete',
        library: 'open',
        fourJokers: 'open',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'complete',
        library: 'complete',
        fourJokers: 'open',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'complete',
        library: 'open',
        fourJokers: 'complete',
        lastStand: 'locked',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'complete',
        library: 'complete',
        fourJokers: 'complete',
        lastStand: 'open',
        machine: 'locked',
        gameState: 'continueGame'

    },
    {
        office: 'complete',
        laboratory: 'complete',
        library: 'complete',
        fourJokers: 'complete',
        lastStand: 'complete',
        machine: 'open',
        gameState: 'machineGame'
    },
    {
        office: 'complete',
        laboratory: 'complete',
        library: 'complete',
        fourJokers: 'complete',
        lastStand: 'complete',
        machine: 'complete',
        gameState: 'winGame'
    }
]

export default gameStages